import React from 'react';
import PropTypes from 'prop-types';

const ColBreak = ({ hasRule }) => {
  let className = 'w-100 mb-2';
  if (hasRule) className += ' pb-2 border-bottom ';

  return <div className={className} />;
};

ColBreak.defaultProps = {
  hasRule: false
};

ColBreak.propTypes = {
  hasRule: PropTypes.bool
};

export default ColBreak;
